import { Api } from '@/api/api';
import { AppointmentListRequestFilters } from '@/api/requests/appointments/appointment-list-request-filters';
import { CreateAppointmentOutcomeRequest } from '@/api/requests/appointments/create-appointment-outcome-request';
import { CreateAppointmentRequest } from '@/api/requests/appointments/create-appointment-request';
import { UpdateAppointmentRequest } from '@/api/requests/appointments/update-appointment-request';
import { Appointment } from '@/shared/appointments/appointment';
import { UpdateAppointmentOutcomeRequest } from './requests/appointments/update-appointment-outcome-request';

export class AppointmentApi extends Api {
    public async getAppointmentsAsync(filters: AppointmentListRequestFilters | null = null): Promise<Array<Appointment>> {
        return await this.getAsync<Array<Appointment>>(`v1/appointment`, filters);
    }

    public async getAppointmentByIdAsync(id: string): Promise<Appointment> {
        return await this.getAsync<Appointment>(`v1/appointment/${id}`);
    }

    public async createAppointmentAsync(request: CreateAppointmentRequest): Promise<string> {
        const url = this.buildUrl(`v1/appointment`);
        const location = await this.postAsync<string>(`v1/appointment`, { ...request });
        return location.replace(`${url}/`, ``);
    }

    public async reBookAppointmentAsync(appointmentId: string, request: CreateAppointmentRequest): Promise<string> {
        const url = this.buildUrl(`v1/appointment/${appointmentId}/rebook`);
        const location = await this.postAsync<string>(`v1/appointment/${appointmentId}/rebook`, { ...request });
        return location.replace(`${url}/`, ``);
    }

    public async updateAppointmentAsync(appointmentId: string, request: UpdateAppointmentRequest): Promise<string> {
        const url = this.buildUrl(`v1/appointment/${appointmentId}`);
        const location = await this.putAsync<string>(`v1/appointment/${appointmentId}`, { ...request });
        return location.replace(`${url}/`, ``);
    }

    public async createAppointmentOutcomeAsync(appointmentId: string, request: CreateAppointmentOutcomeRequest): Promise<string> {
        const url = this.buildUrl(`v1/appointment/${appointmentId}/outcome`);
        const location = await this.postAsync<string>(`v1/appointment/${appointmentId}/outcome`, request);
        return location.replace(`${url}/`, ``);
    }

    public async updateAppointmentOutcomeAsync(appointmentId: string, appointmentOutcomeId: string, request: UpdateAppointmentOutcomeRequest): Promise<string> {
        const url = this.buildUrl(`v1/appointment/${appointmentId}/outcome}/${appointmentOutcomeId}`);
        const location = await this.putAsync<string>(`v1/appointment/${appointmentId}/outcome/${appointmentOutcomeId}`, request);
        return location.replace(`${url}/`, ``);
    }

    public async deleteAppointmentAsync(appointment: Appointment): Promise<string> {
        const url = this.buildUrl(`v1/appointment/${appointment.id}`);
        const location = await this.deleteAsync<string>(`v1/appointment/${appointment.id}`);
        return location.replace(`${url}/`, ``);
    }

    public async deleteAppointmentOutcomeAsync(appointment: Appointment): Promise<string> {
        const url = this.buildUrl(`v1/appointment/${appointment.id}/outcome`);
        const location = await this.deleteAsync<string>(`v1/appointment/${appointment.id}/outcome`);
        return location.replace(`${url}/`, ``);
    }

    public constructor() {
        super();
    }
}
